/* eslint-disable sort-keys */
/* eslint-disable react/sort-prop-types */
/* eslint-disable complexity */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool, object, number, string, oneOfType, func } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import TermosRegulamento from '../../../components/TermosRegulamento/TermosRegulamento'
import PagamentoCartaoCreditoConclusao from './PagamentoCartaoCreditoConclusao'
import PagamentoPixConclusao from './PagamentoPixConclusao'
import CupomPromocao from '../../../components/CupomPromocao/CupomPromocao'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX } from '../../../constants'
import {
  ETAPA_PAGAMENTO,
  ETAPA_PLANO,
  TITULO_PAGAMENTO_TELA_RESUMO
} from '../constantsFluxosPagamento'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { TIPO_PROMOCAO_CRIACAO_ASSINATURA } from '../../../components/CupomPromocao/constantsPromocao'
import ValorTotal from '../components/ValorTotal'

const WrapperResumoPagamentoTotal = styled.div`
  .titulo__total {
    align-items: center;
    display: flex;
    margin-top: 30px;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-top: 10px;
    }

    small {
      ${StyleGuide.tipografia.textoPequeno};
      color: ${StyleGuide.cores.cinza300};
      margin-left: 10px;
    }

    h2 {
      margin-bottom: 0;
    }

    p {
      ${StyleGuide.boldFonte};
      margin-left: 2px;
    }
  }

  a {
    ${StyleGuide.tipografia.textoPequeno};
    text-decoration: underline;
  }
`
const PixDiscountDisplay = styled.div`
  margin-top: 10px;
  ${StyleGuide.tipografia.textoPequeno}
`

const ResumoPagamentoConclusao = ( {
  dadosDescontoCombo,
  etapaAtual,
  fluxoTemPromocao,
  hasDadosEtapa,
  hasDadosPagamento,
  hasDadosPlano,
  idAssinatura,
  labelBotaoUltimaEtapa,
  tipoAssinaturaPromocao,
  valorPlanoConclusao,
  valorTotalPlanoConclusao,
  tipoFluxo,
  modalidadeSelecionadaConclusao,
  dadosGlobaisAssociado,
  setDescontoTotalSegundaAssinatura,
  precoFreteEntrega
} ) => {
  const { dadosEtapas, setarDadosEtapas } = useFluxosPagamento()
  const [ valorDesconto, setValorDesconto ] = useState( 0 )
  const [ dadosPagamento, setDadosPagamento ] = useState( hasDadosPagamento &&
      !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ] ) &&
      dadosEtapas[ ETAPA_PAGAMENTO ] )
  const isPagamentoCartaoCredito =
    hasDadosPagamento &&
    dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento ===
      METODO_PAGAMENTO_CARTAO.slug
  const isPagamentoPix =
    hasDadosPagamento &&
    dadosEtapas[ ETAPA_PAGAMENTO ].metodoPagamento ===
      METODO_PAGAMENTO_PIX.slug
  const hasPromocaoEmPagamento =
    hasDadosPagamento &&
    dadosEtapas[ ETAPA_PAGAMENTO ].promocao &&
    !isEmptyObject( dadosEtapas[ ETAPA_PAGAMENTO ].promocao )
  const podeTerPromocao =
    hasDadosPagamento &&
    tipoAssinaturaPromocao &&
    hasDadosPlano &&
    valorPlanoConclusao &&
    fluxoTemPromocao

  useEffect( () => {
    const valorDescontoCombo = dadosDescontoCombo || 0
    setDescontoTotalSegundaAssinatura( valorDescontoCombo + valorDesconto )
  }, [ dadosDescontoCombo, valorDesconto ] )

  const metodoPagamentoInicial = () => {
    if ( isPagamentoPix ) {
      return METODO_PAGAMENTO_PIX.inicial
    }
    return METODO_PAGAMENTO_CARTAO.inicial
  }

  const validarPromocaoNoFluxo = promocao => {
    if ( promocao.isPromocaoValida ) {
      const dados = { ...dadosEtapas[ ETAPA_PAGAMENTO ], ...{ promocao } }
      setarDadosEtapas( dados, ETAPA_PAGAMENTO )
      setDadosPagamento( dados )
    } else if (
      !isEmptyObject( dadosPagamento.promocao ) &&
      !promocao.isPromocaoValida &&
      dadosPagamento.promocao.codigo !== promocao.codigo
    ) {
      const {
        'promocao': promocaoRemovida,
        ...pagamentoSemPromocao
      } = dadosEtapas[ ETAPA_PAGAMENTO ]
      setarDadosEtapas( pagamentoSemPromocao, ETAPA_PAGAMENTO )
      setDadosPagamento( pagamentoSemPromocao )
    }
  }

  return (
    <WrapperResumoPagamentoTotal>
      <h4>{TITULO_PAGAMENTO_TELA_RESUMO}</h4>

      {isPagamentoCartaoCredito ? <PagamentoCartaoCreditoConclusao etapaAtual={ etapaAtual } /> : null}

      {isPagamentoPix ? <PagamentoPixConclusao /> : null}

      {podeTerPromocao ?
        <CupomPromocao
          email={ dadosGlobaisAssociado.associado.email }
          formaPagamento={ metodoPagamentoInicial() }
          freteEntrega={ precoFreteEntrega || 0 }
          idAssinatura={
            tipoAssinaturaPromocao === TIPO_PROMOCAO_CRIACAO_ASSINATURA
              ? 0
              : idAssinatura
          }
          idPlano={ hasDadosPlano ? dadosEtapas[ ETAPA_PLANO ].id : null }
          onConfirmar={ promocao => validarPromocaoNoFluxo( promocao ) }
          promocaoExterna={
            hasPromocaoEmPagamento ? dadosPagamento.promocao.codigo : null
          }
          setValorDesconto={ setValorDesconto }
          tipoAssinatura={ tipoAssinaturaPromocao }
          valorPlanoConclusao={ valorPlanoConclusao }
        /> : null}

      <div>
        {hasDadosEtapa ?
          <ValorTotal
            dadosGlobaisAssociado={ dadosGlobaisAssociado }
            formaPagamento={ metodoPagamentoInicial() }
            modalidadeSelecionadaConclusao={ modalidadeSelecionadaConclusao }
            nroParcelas={ dadosEtapas[ ETAPA_PAGAMENTO ].parcela }
            precoFreteEntrega={ precoFreteEntrega }
            tipoFluxo={ tipoFluxo }
            tipoPlano={ dadosEtapas[ ETAPA_PLANO ].tipo }
            valorDescontoCombo={ dadosDescontoCombo || 0 }
            valorDescontoCupom={ valorDesconto }
            valorPlanoTotal={ valorTotalPlanoConclusao }
          /> : null}

        { ( isPagamentoPix && METODO_PAGAMENTO_PIX.desconto !== 0 ) ?
          <PixDiscountDisplay>Desconto para pagamento com PIX: {METODO_PAGAMENTO_PIX.desconto}%</PixDiscountDisplay>
          : null}

        <TermosRegulamento nomeBotao={ labelBotaoUltimaEtapa.toLowerCase() } />
      </div>
    </WrapperResumoPagamentoTotal>
  )
}


ResumoPagamentoConclusao.defaultProps = {
  'idAssinatura': null,
  'setDescontoTotalSegundaAssinatura': () => null
}

ResumoPagamentoConclusao.propTypes = {
  'dadosDescontoCombo': oneOfType( [ number, bool ] ).isRequired,
  'etapaAtual': object.isRequired,
  'fluxoTemPromocao': bool.isRequired,
  'hasDadosEtapa': bool.isRequired,
  'hasDadosPagamento': bool.isRequired,
  'hasDadosPlano': bool.isRequired,
  'idAssinatura': number,
  'labelBotaoUltimaEtapa': string.isRequired,
  'tipoAssinaturaPromocao': string.isRequired,
  'valorPlanoConclusao': number.isRequired,
  'valorTotalPlanoConclusao': number.isRequired,
  'tipoFluxo': string.isRequired,
  'modalidadeSelecionadaConclusao': string.isRequired,
  'dadosGlobaisAssociado': object.isRequired,
  'precoFreteEntrega': number.isRequired,
  'setDescontoTotalSegundaAssinatura': func.isOptional,
}

export default ResumoPagamentoConclusao
